import { render, staticRenderFns } from "./account.vue?vue&type=template&id=2cfe4492&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"
import style0 from "./account.vue?vue&type=style&index=0&id=2cfe4492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfe4492",
  null
  
)

export default component.exports